import { ActionDataType } from '../_reducer/types';
import { COUNTRY_INFO_ACTIONS } from './countryInfo.action';
import { CountryInfo } from './countryInfo';

const initialState: CountryInfo = {
  country_code: 'GB'
};

const CountryInfoReducer = (state = initialState, action: ActionDataType) => {
  switch (action.type) {
    case COUNTRY_INFO_ACTIONS.SET_COUNTRY_INFO:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
};
export default CountryInfoReducer;
